import { render, staticRenderFns } from "./DistrictOtherLocations.vue?vue&type=template&id=0264ef4e"
import script from "./DistrictOtherLocations.vue?vue&type=script&lang=ts"
export * from "./DistrictOtherLocations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports